import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, Search, MessageCircle } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen relative overflow-hidden flex items-center justify-center">
      {/* Background */}
      <div className="fixed inset-0 bg-gradient-mesh animate-mesh-move opacity-40" />
      <div className="fixed inset-0 bg-gradient-opal-radial animate-gradient-shift" style={{ backgroundSize: '200% 200%' }} />
      
      {/* Content */}
      <div className="relative z-10 container px-4 text-center">
        <div className="max-w-2xl mx-auto space-y-8">
          {/* 404 Number */}
          <div className="space-y-4">
            <h1 className="text-8xl md:text-9xl font-bold gradient-x-animated">
              404
            </h1>
            <h2 className="text-3xl md:text-4xl font-bold">
              Page Not Found
            </h2>
          </div>

          {/* Description */}
          <p className="text-xl text-muted-foreground max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved. Let's get you back on track.
          </p>

          {/* Quick Links */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <Button 
              size="lg" 
              className="bg-gradient-primary hover:shadow-glow-primary transition-all duration-300"
              asChild
            >
              <a href="/">
                <Home className="w-5 h-5 mr-2" />
                Back to Home
              </a>
            </Button>
            <Button 
              size="lg" 
              variant="secondary"
              className="border border-primary/20"
              asChild
            >
              <a href="/#pricing-features">
                <Search className="w-5 h-5 mr-2" />
                View Pricing
              </a>
            </Button>
            <Button 
              size="lg" 
              variant="secondary"
              className="border border-primary/20"
              asChild
            >
              <a href="/#discord">
                <MessageCircle className="w-5 h-5 mr-2" />
                Join Community
              </a>
            </Button>
          </div>

          {/* Popular Links */}
          <div className="pt-8 border-t border-border/50">
            <p className="text-sm text-muted-foreground mb-4">Popular Pages</p>
            <div className="flex flex-wrap gap-4 justify-center">
              <a href="/#faq" className="text-sm text-primary hover:underline">FAQ</a>
              <a href="/#token-benefits" className="text-sm text-primary hover:underline">Token Benefits</a>
              <a href="/#bitget" className="text-sm text-primary hover:underline">Our CEX partner</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
